// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29P5N","name":"Header_name__3j7N9","birthday":"Header_birthday__j3Tx6","skeleton":"Header_skeleton__2HszG"};